<template>
  <div v-loading.body="loading" class="">
    <page-header
      title="View and Edit Meeting"
      breadcrumb="CRM > Meetings > View Schedule"
    />

    <div class="card">
      <div class="flex justify-between">
        <div>
          <p class="text-deepBlue font-semibold">View Scheduled Meeting</p>
        </div>
        <div>
          <img src="@/assets/images/icons/info.svg" alt="information icon" />
        </div>
      </div>
      <div class="mt-8">
          <table>
              <thead>
                  <tbody>
                      <tr>
                          <td>Meeting Type:</td>
                          <td>{{meeting.label}}</td>
                      </tr>
                      <tr>
                          <td>Meeting Starts:</td>
                          <td>{{meeting.startDate}}, {{ meeting.startTime }}</td>
                      </tr>
                      <tr>
                          <td>Meeting Ends:</td>
                          <td>{{meeting.endDate}}, {{meeting.endTime}}</td>
                      </tr>
                      <!-- <tr>
                          <td>Contact:</td>
                          <td>Seminar</td>
                      </tr> -->
                      <tr>
                          <td>Attendees:</td>
                          <td>
                            <span v-for="attendee in meeting.meetingContacts" :key="attendee.id">
                              <span class="attendee capitalize">{{attendee.name}} </span> 
                            </span>
                          </td>
                      </tr>
                      <tr>
                          <td>Venue:</td>
                          <td>{{meeting.venue}}</td>
                      </tr>
                      <tr>
                          <td>Agenda:</td>
                          <td>{{meeting.description}}</td>
                      </tr>
                      <tr>
                          <td>Comments:</td>
                          <td>{{meeting.comment}}</td>
                      </tr>
                  </tbody>
              </thead>
          </table>
      </div>
      <div class="mt-8">
          <primary-button buttonText="Edit This Schedule" @click="$router.push(`/crm/meetings/edit/${meeting.id}`)" />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      meeting: {},
      loading: false
    };
  },
  watch: {},
  mounted() {
    this.getMeetingDetails();
  },
  methods: {
    async getMeetingDetails() {
      this.loading = true
      try {
        const response = await this.$_getSingleMeeting(this.$route.params.id);
        this.logResponse(response);
        this.meeting = response.data
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false
    },
  },
};
</script>

<style scoped>
td {
    padding: 1rem 0;
    font-size: 0.9rem;
}
td:first-of-type {
    font-weight: bold;
}
td:last-of-type {
    padding-left: 3rem;
}

.attendee {
  background: #f2f7fc;
  border: 0.5px solid #8cafd3;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0.35rem 0.75rem;
  margin: 0.75rem 1rem 0.75rem 0;
  font-size: 0.8rem;
}
</style>
